import styled from 'styled-components';


export const FooterWrapper = styled.div`
  background:#01606F;
 padding:43px 0;
 @media screen and (max-width:767px) { 
    padding:40px 0 0 0 ;
 }

 .write-yellow-btn{ 
    width: 100%; 
    padding: 14px 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    display: inline-flex; 
    justify-content: center;
    gap: 10px;

   &:hover{
    background:#FFFFFF !important;
    color:#01606F !important;
    border:1px solid #FFFFFF !important;
    path{
        stroke:#01606F;
    }
   } 
   @media screen and (max-width:767px) { 
    padding: 10px 0;
    font-size: 16px;
    line-height: 25px;
   }
 }
 .right-col{
    padding-left: 75px;

    @media screen and (max-width:1024px){
        padding-left: 30px;
    }

    @media screen and (max-width:767px) { 
        padding-left: 12px;
        padding-top: 30px;
    }
 }
`;

export const FooterText = styled.div`
    color: #FFFFFF;
    font-family: "Jost", sans-serif;
    font-size: 16px;
    font-weight:300;
    line-height: 24px;
    margin:20px 0 30px 0;
`;

export const LinkHeading = styled.h3`
    color: #FFFFFF;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    font-weight:600;
    line-height: 24px;
    margin-bottom:0;
    position: relative;
    &:after {
        background: rgb(255 255 255 / 50%);
        position: absolute;
        width: 60px;
        height: 1px;
        content: "";
        bottom: -10px;
        left: 0;
    }
`;


export const LinkList = styled.ul`
     padding: 0;
     margin: 30px 0 0 0;
     list-style: none;
     
`;

export const LinkItem = styled.li`
    margin: 0px 0 10px 0;
    display: flex;
    gap: 10px;
     @media screen and (max-width:767px) {
       align-items: center;
    }
 a{
    color: #FFFFFF;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 300;
    line-height: 25px;
    text-decoration: none;
    display: flex;
    gap: 12px; 
    align-items: center;
    transition: all 0.3s;
    &:hover{
        color:#F9DC70;
    }
    &:nth-child(2){
        img{
            filter: invert(1);
        }
       
    }
    &.more-city {
        font-weight: 700;
        text-decoration: underline;
        padding:6px 0px;
        @media screen and (max-width:767px) {
         padding:0;
        }
       
    }
 } 
 span{
    background: #F9DC70 0% 0% no-repeat padding-box;
    border-radius: 10px;
    width:36px;
    min-width:36px;
    height:36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
   
 }

`;


export const TopFooter = styled.div`
    border-bottom: 1px solid rgb(255 255 255 / 50%);
    padding-bottom:20px;
  .footer-org-btn{
    text-decoration: none;
  }
`;

export const FooterLogoImage = styled.div`
img{
    width:100%;
    max-width:350px;
    @media screen and (max-width:767px) {
        max-width:250px;
    }
  }

`;
export const BottomFooter = styled.div`
   padding-top:30px;
  ${LinkList}{
    column-count: 3;
    @media screen and (max-width:767px) {
        margin-bottom: 30px;
          column-count: 2;
          display:block;
     }
  }
button.btn.btn-primary {
    background: transparent;
    border: none;
    padding-left: 0;
    padding-right: 0;
    text-align: left;
    @media screen and (max-width:767px) {
        padding:0;
    }
}
 ul{
     padding: 0px;
    margin: 30px 0px 0px;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    }
li{
      margin: 10px 0;
    display: flex;
    gap: 10px;
    width: calc(33.33% - 0px);
     @media screen and (max-width:767px) {
        width:100%;
         margin: 0 0 6px 0;
     }
}
`;

export const CopyRightFooter = styled.div`
    background: #016B7B 0% 0% no-repeat padding-box;
    padding: 23px 15px;
    text-align: center;
    color: #fff;
    font-size: 12px;
    line-height: 25px;
    font-family: "Jost", sans-serif;
    font-weight: 300;

    a{
        color: #fff;
        text-decoration: none;

        &:hover{
             color: #FFD495;
        }
    }
`;


export const TopBottombtn = styled.div`
    position: absolute;
    background: #FFD495;;
    z-index: 9999;
    right: 16px;
    margin-top: -50px;
    border-radius: 5px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    img{
     filter: brightness(1) invert(1);
     transform: rotate(180deg); 
    }
`;